// coffeelint: disable
angular.module('shared').factory('CreditCardValidationService', function() {
  var luhnCheck;
  // Luhn algorithm: validate credit card number
  // https://en.wikipedia.org/wiki/Luhn_algorithm
  luhnCheck = (function(arr) {
    return function(ccNum) {
      var bit, len, sum, val;
      len = ccNum.length;
      bit = 1;
      sum = 0;
      val = void 0;
      while (len) {
        val = parseInt(ccNum.charAt(--len), 10);
        sum += (bit ^= 1) ? arr[val] : val;
      }
      return sum && sum % 10 === 0;
    };
  })([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);
  return {
    check: function(creditCard) {
      if (creditCard) {
        return luhnCheck(creditCard);
      }
    },
    nameValid: function(name) {
      return name && !!name.match(/[a-z]/i);
    }
  };
});

// coffeelint: enable
